import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AWS from "aws-sdk";
import { CUSTARD_CATEGORY, HAND_SCOOPED_CUSTARD_CATEGORY } from "../utils/constants";

const RecipeCardPreview = ({
  showRecipeCards,
  selectedFlavor,
  handleCloseRecipeCards,
}) => {
  console.log(selectedFlavor)
  let gallon = false;
  if (
    selectedFlavor?.intProductTypeID === HAND_SCOOPED_CUSTARD_CATEGORY ||
    selectedFlavor?.intProductTypeID === CUSTARD_CATEGORY
  ) {
    gallon = true;
  }
  const [image, setImage] = useState("");
  const [noimage, setNoImage] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  useEffect(() => {
    // downloadImages(selectedFlavor?.imageURL);
  }, []);
  const s3 = new AWS.S3();

  const imageOnLoad = (event) => {
    console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  const downloadImages = (imageURL) => {
    setImageLoading(true);
    if (imageURL) {
      var url = s3.getSignedUrl("getObject", {
        Bucket: process.env.REACT_APP_AWS_BUCKET,
        Key: `allnaturalorangepineappletest/halfContainer`,
      });
      if (url) {
        setImage(url);
        setTimeout(() => setImageLoading(false), 1000);
      }
    }
  };
  return (
    <Dialog
      maxWidth="sm"
      fullWidth="false"
      // TransitionComponent={Transition}
      sx={{ zIndex: 1000 }}
      PaperProps={{
        style: {
          minWidth: "37%",
          maxWidth: "77%",
          minHeight: "60%",
          maxHeight: "87%",
        },
      }}
      open={showRecipeCards}
      onClose={handleCloseRecipeCards}
    >
      <DialogTitle>{`${selectedFlavor?.flavor_name}`}</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          {selectedFlavor?.quarterContainer && <Grid item xs={12} sm={12} md={6}>
            <div className="flex">
              <h4>{`Quarter`}</h4>
              {imageLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                <div>
                  <img
                    src={selectedFlavor?.quarterContainer}
                    onLoad={imageOnLoad}
                    onError={imageOnError}
                    alt="recipe"
                  />
                </div>
              )}
            </div>
          </Grid>}
          
          {selectedFlavor?.halfContainer && <Grid item xs={12} sm={12} md={6}>
            <div className="flex">
              <h4>{`Half`}</h4>
              {imageLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                <div>
                  <img
                    src={selectedFlavor?.halfContainer}
                    onLoad={imageOnLoad}
                    onError={imageOnError}
                    alt="recipe"
                  />
                </div>
              )}
            </div>
          </Grid>}
          
          {selectedFlavor?.singleContainer && <Grid item xs={12} sm={12} md={6}>
            <div className="flex">
              <h4>{gallon ? `Recipe Card`:`Single`}</h4>
              {imageLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                <div>
                  <img
                    src={selectedFlavor?.singleContainer}
                    onLoad={imageOnLoad}
                    onError={imageOnError}
                    alt="recipe"
                  />
                </div>
              )}
            </div>
          </Grid>}
          {selectedFlavor?.doubleContainer && <Grid item xs={12} sm={12} md={6}>
            <div className="flex">
              <h4>{`Double`}</h4>
              {imageLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                <div>
                  <img
                    src={selectedFlavor?.doubleContainer}
                    onLoad={imageOnLoad}
                    onError={imageOnError}
                    alt="recipe"
                  />
                </div>
              )}
            </div>
          </Grid>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseRecipeCards}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecipeCardPreview;
